import React, { useEffect, useRef, useState } from "react";

const TRAILER_SRC = "/trailer1.mp4";

/**
 * Тяжёлый mp4 не подключается до появления секции в viewport (preload=none).
 * Так тизер не влияет на LCP и не качает сотни МБ при открытии главной.
 */
const LazyTeaserVideo = () => {
    const videoRef = useRef(null);
    const [shouldLoad, setShouldLoad] = useState(false);

    useEffect(() => {
        const node = videoRef.current;
        if (!node) {
            return undefined;
        }

        const observer = new IntersectionObserver(
            (entries) => {
                const [entry] = entries;
                if (entry?.isIntersecting) {
                    setShouldLoad(true);
                    observer.disconnect();
                }
            },
            { rootMargin: "200px 0px", threshold: 0.1 }
        );

        observer.observe(node);
        return () => observer.disconnect();
    }, []);

    return (
        <video
            ref={videoRef}
            className="guest-teaser__video"
            controls
            playsInline
            preload={shouldLoad ? "metadata" : "none"}
            src={shouldLoad ? TRAILER_SRC : undefined}
        >
            Ваш браузер не поддерживает воспроизведение видео.
        </video>
    );
};

export default LazyTeaserVideo;
